module.exports = __webpack_public_path__ + "img/home.9cd23b6.svg";